import React from "react"
import { useSelector } from "react-redux"

const AppLink = ({ link, IconEn, IconAr, height, width, onClick, target }) => {
  const { locale: appLanguage } = useSelector(state => state.app.configs)

  return (
    <a target={target} href={link} onClick={onClick}>
      {appLanguage === "en" ? <IconEn height={height} width={width} /> : <IconAr height={height} width={width} />}
    </a>
  )
}

export default AppLink
